import type { Query_RootNeedsArgs } from '@purposity/sdk'

export type NeedsListParams<
  TFilters extends Query_RootNeedsArgs | undefined =
    | Query_RootNeedsArgs
    | undefined,
> = {
  slug: string
  filters?: TFilters
}

export const needsQK = {
  all: ['needs'] as const,
  lists: () => [...needsQK.all, 'list'] as const,
  list: (params: any) => [...needsQK.lists()[0], params] as const,
  details: () => [...needsQK.all, 'detail'] as const,
  detail: (needId: number) => [...needsQK.details(), needId] as const,
  detailStatus: (needId: number) =>
    [...needsQK.detail(needId), 'status', needId] as const,
}
